/// <amd-module name="SuiteCommerce.StockNotifications.Item.Option.Value.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.StockNotifications.Item.Option.Value.Model", ["require", "exports", "underscore", "Backbone"], function (require, exports, _, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ItemOptionValueModel = /** @class */ (function (_super) {
        __extends(ItemOptionValueModel, _super);
        function ItemOptionValueModel(options) {
            var _this = _super.call(this, options) || this;
            if (options) {
                _this.item = options.item;
            }
            return _this;
        }
        Object.defineProperty(ItemOptionValueModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemOptionValueModel.prototype, "label", {
            get: function () {
                return this.get('label');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemOptionValueModel.prototype, "url", {
            get: function () {
                return this.get('url');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ItemOptionValueModel.prototype, "isAvailable", {
            get: function () {
                return this.get('isAvailable');
            },
            enumerable: true,
            configurable: true
        });
        ItemOptionValueModel.prototype.getIsSelected = function (selectedId) {
            var internalId = this.internalId;
            return !!internalId && !!selectedId && (parseInt(internalId, 10) === parseInt(selectedId, 10));
        };
        ItemOptionValueModel.prototype.getColorInfo = function (colors) {
            var color = '';
            var label = this.label;
            var isColorTile = true;
            var image = {};
            if (colors) {
                color = colors[label] || colors.defaultColor;
                if (_.isObject(color)) {
                    image = color;
                    color = '';
                    isColorTile = false;
                }
            }
            return {
                color: color,
                image: image,
                isColorTile: isColorTile
            };
        };
        return ItemOptionValueModel;
    }(Backbone_1.Model));
    exports.ItemOptionValueModel = ItemOptionValueModel;
});
